// Import necessary types from shared/types and helper functions from ../helpers
import { GameState, PerformActionRequest } from "@shared/types";
import { getJsonApi, postJsonApi } from "../helpers";

// Function to asynchronously fetch the current game state
export async function getState(): Promise<GameState> {
    // Invokes the getJsonApi function with endpoint "state" to retrieve game state
    return getJsonApi<GameState>("state");
}

// Function to asynchronously perform an action in the game
export async function performAction(
    // Alias of the action to perform
    actionAlias: string,
    // Optional array of aliases of objects involved in the action
    objectAliases?: string[],
    input?: string
): Promise<GameState | undefined> {  // Returns a promise of GameState or undefined
    try {
        // Invokes the postJsonApi function with endpoint "action" and PerformActionRequest
        // Sends actionAlias and optional objectAliases as parameters
        return postJsonApi<GameState, PerformActionRequest>("action", {
            // Action alias
            action: actionAlias,
            // Array of object aliases
            objects: objectAliases,
            input: input
        });
    } catch { // Catch any errors that occur during the API call
        return undefined; // Return undefined if there's an error
    }
}
